import CategoriesList from "../../components/admin/categoriesList/CategoriesList";
import {Chip, Stack, Typography} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const CategoriesPage = () => {
    return <>
        <Stack direction='column' sx={{mb: 3}}>
            <Typography variant='h4' color='brAccent'>Lista Categorie Prodotti</Typography>
            <Typography variant='h5' sx={{mb: 2}}>Modifica o aggiungi cateogorie nel menu</Typography>
            <Typography component="div" variant='body1' color='grey'>Clicca <Chip size='small' icon={<AddIcon />} label="Nuovo" color='primary' /> per aggiungere una categoria al menu, <Chip size='small' icon={<EditIcon />} label='Modifica' color='primary' /> per modificarla, <Chip size='small' icon={<DeleteIcon />} label='Elimina' variant='outlined' color='primary' /> per eliminarla.</Typography>
        </Stack>
        <CategoriesList />
    </>
}

export default CategoriesPage;